import React, { useEffect, useState } from 'react';

import MetaTags from 'react-meta-tags';
import Box from "@material-ui/core/Box";
import GeneralStyles from '../../styles/GeneralStyles';
import axios from 'axios';
import { useCookies } from 'react-cookie';
import cookieName from '../../helpers/cookiesDeclaration';
import clsx from "clsx";
import CircularProgress from '@material-ui/core/CircularProgress';
// import { Helmet } from "react-helmet";


const useGeneralStyles = GeneralStyles;


function OurWork(props) {
    const classesG = useGeneralStyles();
    const [ourWork, setOurWork] = useState(null);
    const [ourWorkPage, setOurWorkPage] = useState(null);
    const [firstOurWork, setFirstOurWork] = useState(null);
    const [loading, setLoading] = useState(false);
    const [cookies, setCookie] = useCookies([cookieName]);

    useEffect(() => {
        setLoading(true);
        axios
            .get(
                `${process.env.REACT_APP_GATEWAY_END_POINT}/our-work`)
            .then((response) => {
                setOurWorkPage(response.data);
            })
            .catch((error) => {
                setLoading(true);
            });

        axios
            .get(
                `${process.env.REACT_APP_GATEWAY_END_POINT}/our-work-contents?_sort=Date:DESC`)
            .then((response) => {
                setOurWork(response.data);
                setFirstOurWork(response.data[0]);
                // console.log('NEWS: ' + JSON.stringify(response.data[0]));
                setLoading(false);
            })
            .catch((error) => {
                setLoading(true);
            });

    }, []);

    const handleRedirectOurWork = item => {
        var userD = {};
        userD.urlOurWork = item;
        setCookie(cookieName, JSON.stringify(userD), { path: '/' });

        const { history, location } = props;
        const { from } = location.state || {
            from: {
                pathname: `/ourWorkContent/${item}`,
            },
        };
        history.push(from);
    };

    const replace = (param) => {
        var value = '';

        if (param !== '' && param !== null && param !== undefined) {
            value = param.replace(`${process.env.REACT_APP_GATEWAY_PATH_REPLACE}`, `${process.env.REACT_APP_GATEWAY_PATH_S3}`);
        }

        return value;
    }

    return (
        <React.Fragment>
            {loading && (
                <div className={classesG.divProgress}>
                    <CircularProgress size={68} className={classesG.progress} />
                </div>
            )}
            {!loading && (
                <React.Fragment>
                    {ourWorkPage === null ? '' : (
                        <MetaTags>
                            <title>{ourWorkPage.Page_title}</title>
                            <meta name="description" content={ourWorkPage.Page_description} />
                        </MetaTags>
                    )}
                    <div className={classesG.container}>
                        <section className={classesG.section}>
                            <div className={classesG.workSectionBackground}></div>
                            {firstOurWork === null || firstOurWork === '' || firstOurWork === undefined ? '' :
                                (
                                    firstOurWork.Priority_image === true ? (
                                        <div className={classesG.workSecondSectionContent}>
                                            <div className={classesG.workSectionBox}>
                                                <div className={classesG.workfirstSectionText} onClick={() => handleRedirectOurWork(firstOurWork.Url)}>
                                                    {ourWorkPage === null ? '' : (
                                                        <h2>{ourWorkPage.title}</h2>
                                                    )}
                                                    <div>
                                                        <img src={replace(firstOurWork.Image.url)} alt={firstOurWork.Image.name} />
                                                    </div>
                                                    <h4>{firstOurWork.Title}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className={classesG.workExamplesSecondSectionContent}>
                                            <div className={classesG.workExampleSectionBox}>
                                                <div className={classesG.newsExampleFirstSectionText} >

                                                    {ourWorkPage === null ? '' : (
                                                        <h2>{ourWorkPage.title}</h2>
                                                    )}

                                                    <div className={classesG.divVideo} onClick={() => handleRedirectOurWork(firstOurWork.Url)}>
                                                        <video src={replace(firstOurWork.Background_video.url)}
                                                            playsInline autoPlay={'autoplay'} loop={true} muted id='video1'>
                                                        </video>
                                                    </div>
                                                    <h4
                                                        className={classesG.workH4}
                                                        style={{ color: '#ffffff', marginTop: '16px' }}
                                                        onClick={() => handleRedirectOurWork(firstOurWork.Url)}
                                                    > {firstOurWork.Title}</h4>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                )
                            }

                        </section>

                        <section className={classesG.section}>
                            <div className={classesG.workSecondSectionBackground}></div>
                            <div className={classesG.workSecondSectionContent}>
                                <div className={classesG.sectionBox}>
                                    <div className={classesG.workSecondSectionImages}>
                                        <ul>
                                            {ourWork === null ? '' : ourWork.map((items, i) => (
                                                <React.Fragment>
                                                    {i === 0 ? '' :
                                                        <React.Fragment>
                                                            {
                                                                items.Priority_image === true ?
                                                                    (
                                                                        <li key={items.Url} onClick={() => handleRedirectOurWork(items.Url)}>
                                                                            <div>
                                                                                <img src={replace(items.Image.url)} alt={items.Title} />
                                                                            </div>
                                                                            <h4 className={clsx({
                                                                                [classesG.workH4]: i <= 2,
                                                                                [classesG.workH4_Black]: i > 2,
                                                                            })}>
                                                                                {items.Title}
                                                                            </h4>
                                                                        </li>
                                                                    ) :
                                                                    (
                                                                        <li key={items.Url} onClick={() => handleRedirectOurWork(items.Url)}>
                                                                            <div className={classesG.divVideo} onClick={() => handleRedirectOurWork(items.Url)}>
                                                                                <video src={replace(items.Background_video.url)}
                                                                                    playsInline autoPlay={'autoplay'} loop={true} muted id='video1'>
                                                                                </video>
                                                                            </div>
                                                                            <h4 className={clsx({
                                                                                [classesG.workH4]: i <= 2,
                                                                                [classesG.workH4_Black]: i > 2,
                                                                            })}>
                                                                                {items.Title}
                                                                            </h4>
                                                                        </li>
                                                                    )
                                                            }
                                                        </React.Fragment>
                                                    }
                                                </React.Fragment>
                                            ))}
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </section>

                        <Box mt={7}></Box>
                    </div>
                </React.Fragment>
            )}
        </React.Fragment>
    );
}

export default (OurWork);